import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Bar = _resolveComponent("Bar");
  return _ctx.loading ? (_openBlock(), _createBlock(_component_Bar, {
    key: 0,
    ref: "barchart",
    data: _ctx.dataGraph,
    options: _ctx.options
  }, null, 8, ["data", "options"])) : _createCommentVNode("", true);
}